import React from 'react'
import Media from './media'
import Social from './social'
import Container from '../components/container'

export function Column({ text, links, media }) {
  const { heading, description } = text ?? {}
  const { caption, ...mediaProps } = media ?? {}

  return (
    <article>
      {heading && <h3 className="heading-lg-display">{heading}</h3>}
      {description && <div className="mt-4 body-bs" dangerouslySetInnerHTML={{ __html: description }} />}
      <div className="mt-2">
        {links && <Social {...links} />}
      </div>
      {(caption || mediaProps?.image || mediaProps?.video) && (
        <figure>
          <Media
            autoPlay
            preload="auto"
            muted
            loop
            cover className="mt-6 rounded-xxx border-secondary border-2 overflow-hidden aspect-[4/3]" {...mediaProps} />
          {caption && <figcaption className="mt-2 font-accent 420:text-secondary exxxotica:text-tertiary text-sm">{caption}</figcaption>}
        </figure>
      )}
    </article>
  )
}

export default function FeatureColumns({ content }) {
  const { columns } = content
  let columnClassName

  if (columns.length === 1) {
    columnClassName = 'col-span-12 md:col-start-2 md:col-span-10 lg:col-start-3 lg:col-span-8'
  } else if (columns.length === 2) {
    columnClassName = 'col-span-12 md:col-start-2 md:col-span-10 lg:col-start-auto lg:col-span-6'
  } else {
    columnClassName = 'col-span-12 md:col-start-2 md:col-span-10 lg:col-start-auto lg:col-span-4'
  }

  return (
    columns?.length && (
      <section className="bg-primary text-secondary standard-spacing">
        <Container>
          <ul className="xxx-grid">
            {columns.map((column, key) => (
              <li className={columnClassName} key={key}>
                <Column {...column} />
              </li>
            ))}
          </ul>
        </Container>
      </section>
    )
  )
}
